import gql from 'graphql-tag';

export const BrandFragments = {
  id: gql`
    fragment BrandId on Brand {
      id
    }
  `,
};
